<div class="dialog-header">
  <span class="spacer"></span>
  <label class="header-label">{{ 'Performance Defaults for ' + entityId + ';' + revision }}</label>
  <span class="spacer"></span>
  <button matButton="elevated" class="close-dialog-button warn-button" (click)="close()">
    X
  </button>
</div>
<div class="content">
  @if (entityPerformanceDefaults()) {
    <app-performance-defaults
      [performanceDefaults]="entityPerformanceDefaults().performanceDefaults"
      (selectionChanged)="performanceDefaultUpdated($event)">
    </app-performance-defaults>
  }
  <div class="button-row">
    <span class="spacer"></span>
    <button matButton="elevated" class="dialog-action-button primary-button" [disabled]="isBusy()" (click)="save()">
      Save
    </button>
  </div>
</div>
